import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useConcerns } from '../../contexts/ConcernContext';
import './MyConcerns.css';

function MyConcerns() {
  const navigate = useNavigate();
  const { concerns, deleteConcern, loading } = useConcerns();
  const [deleting, setDeleting] = useState(null);


  console.log(concerns)

  const formatDate = (dateString) => {
    if (!dateString) return null;
    
    // If already formatted (e.g., "Dec 16, 2025"), return as-is
    if (typeof dateString === 'string' && dateString.includes(',')) {
      return dateString;
    }
    
    // Otherwise format it
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    });
  };

  const getPriorityClass = (priority) => {
    return `priority-badge priority-${priority.toLowerCase()}`;
  };

  const getStatusClass = (status) => {
    return `status-badge status-${status.toLowerCase()}`;
  };

  const handleDelete = async (id) => {
    if (window.confirm('Are you sure you want to delete this concern?')) {
      setDeleting(id);
      
      const result = await deleteConcern(id);
      
      if (result.success) {
        console.log('Concern deleted successfully');
      } else {
        alert(`Failed to delete concern: ${result.error}`);
      }
      
      setDeleting(null);
    }
  };

  if (loading) {
    return (
      <div className="my-concerns-page">
        <nav className="dashboard-nav">
          <div className="container nav-content">
            <h2 className="logo">EngineeringCubes</h2>
            <button onClick={() => navigate('/client-dashboard')} className="btn btn-secondary">
              Back to Dashboard
            </button>
          </div>
        </nav>
        <div className="page-content">
          <div className="container">
            <p>Loading concerns...</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="my-concerns-page">
      <nav className="dashboard-nav">
        <div className="container nav-content">
          <h2 className="logo">EngineeringCubes</h2>
          <button onClick={() => navigate('/client-dashboard')} className="btn btn-secondary">
            Back to Dashboard
          </button>
        </div>
      </nav>

      <div className="page-content">
        <div className="container">
          <div className="page-header">
            <div>
              <h1 className="page-title">My Concerns</h1>
              <p className="page-subtitle">Track all your submitted concerns</p>
            </div>
            <button onClick={() => navigate('/submit-concern')} className="btn btn-primary">
              + New Concern
            </button>
          </div>

          {concerns.length === 0 ? (
            <div className="empty-state">
              <h3>No concerns submitted yet</h3>
              <p>Submit your first concern to get started</p>
              <button onClick={() => navigate('/submit-concern')} className="btn btn-primary">
                Submit Concern
              </button>
            </div>
          ) : (
            <div className="concerns-list">
              {concerns.map((concern) => (
                <div key={concern.id} className="concern-card">
                  <div className="concern-header">
                    <h3 className="concern-title">{concern.title}</h3>
                    <div className="concern-badges">
                      <span className={getPriorityClass(concern.priority)}>
                        {concern.priority}
                      </span>
                      <span className={getStatusClass(concern.status)}>
                        {concern.status}
                      </span>
                    </div>
                  </div>

                  <div className="concern-meta">
                    <span className="concern-category">{concern.category}</span>
                    {concern.location && (
                      <>
                        <span className="separator">•</span>
                        <span className="concern-location">{concern.location}</span>
                      </>
                    )}
                    <span className="separator">•</span>
                    <span className="concern-date">Submitted: {formatDate(concern.submittedDate)}</span>
                  </div>

                  <p className="concern-description">{concern.description}</p>

                  {/* Engineer Notes Section */}
                  {concern.engineer_note && (
                    <div className="concern-engineer-notes">
                      <h4>Engineer Notes:</h4>
                      <p>{concern.engineer_note}</p>
                      {concern.engineer_email && (
                      <p className="engineer-info">
                        By: {concern.engineer_email}
                      </p>
                    )}
                    </div>
                  )}

                  {/* Resolution Section */}
                  {concern.resolution && (
                    <div className="concern-resolution">
                      <h4>Resolution:</h4>
                      <p>{concern.resolution}</p>
                      {concern.resolvedDate && (
                        <p className="resolved-date">
                          Resolved on: {formatDate(concern.resolvedDate)}
                        </p>
                      )}
                      {concern.engineer_email && (
                      <p className="engineer-info">
                        By: {concern.engineer_email}
                      </p>
                    )}
                    </div>
                  )}

                  <div className="concern-actions">
                    <button 
                      onClick={() => handleDelete(concern.id)} 
                      className="btn-delete"
                      disabled={deleting === concern.id}
                    >
                      {deleting === concern.id ? 'Deleting...' : 'Delete'}
                    </button>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default MyConcerns;